import { useMemo } from "react";
import { useSelector } from "react-redux";
import { usePermissions } from "./usePermissions";
import { scopeCustomers } from "../../functions/permissions";

/**
 * De webshopklanten (store `webshopUsers`) beperkt tot de scope van de
 * ingelogde gebruiker: landen, een klantselectie, of alles. Zonder beperking
 * is dit exact dezelfde array als in de store. Gebruik dit in plaats van
 * `state.firestoreReducer.ordered.webshopUsers` waar klanten getoond worden.
 */
export const useScopedCustomers = () => {
  const allUsers = useSelector((state) => state.firestoreReducer.ordered.webshopUsers);
  const { scope } = usePermissions();
  return useMemo(() => scopeCustomers(allUsers, scope), [allUsers, scope]);
};

export default useScopedCustomers;
